export const getPricingOfAccountRCSCampaign = {
  REQUEST: 'GET_PRICING_OF_ACCOUNT_RCS_CAMPAIGN_REQUEST',
  SUCCESS: 'GET_PRICING_OF_ACCOUNT_RCS_CAMPAIGN_SUCCESS',
  ERROR: 'GET_PRICING_OF_ACCOUNT_RCS_CAMPAIGN_ERROR',
};

export const editPricingOfAccountRCSCampaign = {
  REQUEST: 'EDIT_PRICING_OF_ACCOUNT_RCS_CAMPAIGN_REQUEST',
  SUCCESS: 'EDIT_PRICING_OF_ACCOUNT_RCS_CAMPAIGN_SUCCESS',
  ERROR: 'EDIT_PRICING_OF_ACCOUNT_RCS_CAMPAIGN_ERROR',
};
